import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Switcher } from '@s7/ui-kit';
import classNames from 'classnames/bind';
import styles from './ProviderSwitcher.css';
import { setHeaders } from '../api';
var cx = classNames.bind(styles);
export var ProviderSwitcher = function ProviderSwitcher() {
  var defaultChecked = localStorage.getItem('lws7lmsprovider') === 'true';

  var _useState = useState(defaultChecked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var handleChecked = function handleChecked() {
    setChecked(!checked);
  };

  useEffect(function () {
    if (checked) {
      localStorage.setItem('lws7lmsprovider', true);
      setHeaders({
        provider: checked ? 's7lms' : undefined
      });
    } else {
      localStorage.removeItem('lws7lmsprovider');
      setHeaders({
        provider: undefined
      });
    }
  }, [checked]);
  return /*#__PURE__*/React.createElement(Switcher, {
    checked: checked,
    classes: {
      root: cx('ProviderSwitcher')
    },
    onChange: handleChecked
  }, "S7 LMS");
};